export const GET_EXPERIENCES = "GET_EXPERIENCES";
export const RESET_EXPERIENCES = "RESET_EXPERIENCES";
export const SET_EXPERIENCES_REQUEST_STATUS = "SET_EXPERIENCES_REQUEST_STATUS";
